export default {"src":"/_next/static/media/hofMwebBannerDark.0f4a3719.svg","height":115,"width":336};